"use client";

import { Plus } from "lucide-react";

import { SettingsActionButton } from "@/components/admin/settings-form-controls";

export function AdminTableToolbar({
  addLabel,
  onAdd,
  trailing,
  align = "end",
  addDisabled = false,
  actions,
}: {
  addLabel?: string;
  onAdd?: () => void;
  trailing?: React.ReactNode;
  align?: "start" | "end";
  addDisabled?: boolean;
  actions?: React.ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      {align === "end" && trailing ? <div className="flex flex-wrap items-center gap-2">{trailing}</div> : null}
      <div className={`flex flex-wrap items-center gap-2 ${align === "end" ? "ml-auto" : ""}`}>
        {addLabel && onAdd ? (
          <SettingsActionButton
            active
            requireActive={false}
            size="sm"
            onClick={onAdd}
            disabled={addDisabled}
          >
            <Plus className="size-4" />
            {addLabel}
          </SettingsActionButton>
        ) : null}
        {actions}
      </div>
      {align === "start" && trailing ? <div className="flex items-center gap-2">{trailing}</div> : null}
    </div>
  );
}
